import React, { useContext } from 'react';
import { ConfigContext } from '../../context/Config';
import Text from '../Text/Text';
import DateViewer from '../DateViewer/DateViewer';
import TimeViewerESchool from '../TimeViewerESchool';
import Avatar from '../Avatar/Avatar';
import isEmpty from 'lodash/isEmpty';
import PracticeActionsESchool from '../PracticeActionsESchool';
import Wrapper from '../Wrapper';
import Button from '../Button';
import './CalendarEventViewItem.less';

export type Attendee = {
  id?: string;
  name: string;
  avatar?: string;
};

export type Event = {
  id?: string;
  title: string;
  eventStartDate: string;
  eventEndDate: string;
  attendees: Attendee[];
  meetingLinks?: { [key: string]: string };
  altLink?: string;
  color?: string;
  type?: 'event' | 'booking';
};

export type CalendarEventViewItemProps = Event & {
  locale?: string;
  onItemClick?: (item: any) => void;
  onBook?: (item: any) => void;
};

const TCalendarEventViewItem: React.FC<CalendarEventViewItemProps> = ({
  title,
  eventStartDate,
  eventEndDate,
  attendees = [],
  meetingLinks,
  type = 'event',
  locale,
  onItemClick,
  onBook,
}) => {
  const { translate } = useContext(ConfigContext);

  const link =
    !isEmpty(meetingLinks) &&
    !!Object.values(meetingLinks)[0] &&
    Object.values(meetingLinks)[0];

  const TimeAndEvents = ({ className = 'e-timeAndEvents' }) => {
    return (
      <div className={className}>
        <div className="e-time-viewer-wrapper">
          <TimeViewerESchool
            locale={locale}
            start={eventStartDate}
            end={eventEndDate}
            rows={2}
          />
        </div>
        {type === 'booking' && (
          <Wrapper display="flex" justifyContent="flex-end">
            <Button onClick={onBook}>{translate('ui.book')}</Button>
          </Wrapper>
        )}
        {type !== 'booking' && <PracticeActionsESchool trainingLink={link} />}
      </div>
    );
  };

  return (
    <div className="e-calendarListItem" onClick={onItemClick}>
      <div className="e-infoContainer">
        <div className="e-dateContainer">
          <div className="t-dateView">
            <div className="e-border-left"></div>
            <DateViewer locale={locale} date={eventStartDate} />

            <div className="e-titleAndImages-mobile">
              <Text level={2} rows={1} bold paddingBottom={2}>
                {title}
              </Text>
              {attendees.length > 0 && (
                <div className="e-avatarGroup">
                  <Avatar
                    src={attendees[0]?.avatar}
                    name={attendees[0]?.name}
                    size="xs"
                    text={attendees[0]?.name}
                    textLevel={3}
                  />
                </div>
              )}
            </div>
          </div>

          <TimeAndEvents className="e-timeAndEvents-mobile" />
        </div>

        <div className="e-titleAndImages">
          <Text level={2} rows={1} bold paddingBottom={2}>
            {title}
          </Text>
          {attendees.length > 0 && (
            <div className="e-avatarGroup">
              <Avatar
                src={attendees[0]?.avatar}
                name={attendees[0]?.name}
                size="xs"
                text={attendees[0]?.name}
                textLevel={3}
              />
            </div>
          )}
        </div>
      </div>
      <TimeAndEvents />
    </div>
  );
};

export default TCalendarEventViewItem;
